import { ProductInfo, MissingProductItem } from 'sofa-reborn-react';

import { ProductData, Product, SprItem } from '@ikea-aoa/component-view-3d';

export default class MissingProductsParser {
	public parse(
		products: ProductData,
		productInfo: ProductInfo,
		sofaRangeIsModular: boolean
	): { missingProducts: MissingProductItem[]; missingArmrestCovers: string[] } {
		const missingProducts: MissingProductItem[] = [];
		const missingArmrestCovers: string[] = [];
		this.handleMissing(
			products,
			productInfo,
			sofaRangeIsModular,
			missingArmrestCovers,
			missingProducts
		);

		// Armrest missing remove all modules in that color
		this.removeProductsWithSpecificColor(products, missingArmrestCovers, missingProducts);

		return { missingProducts, missingArmrestCovers };
	}

	private handleMissing(
		products: ProductData,
		productInfo: ProductInfo,
		sofaRangeIsModular: boolean,
		missingArmrestCovers: string[],
		missingProducts: MissingProductItem[]
	) {
		Object.entries(products).forEach(([key, product]) => {
			const { productId, sprItems } = product as Product;
			if (sprItems && sprItems.length) {
				this.handleSprItems(
					sprItems,
					productInfo,
					products,
					key,
					sofaRangeIsModular,
					missingArmrestCovers,
					missingProducts,
					productId
				);
			} else if (
				!productInfo[productId.replace('_mirror', '')] &&
				productId !== 'leg' &&
				!productId.includes('arm')
			) {
				this.handleArticles(
					products,
					key,
					sofaRangeIsModular,
					missingArmrestCovers,
					missingProducts
				);
			}
		});
	}

	private handleArticles(
		products: ProductData,
		key: string,
		sofaRangeIsModular: boolean,
		missingArmrestCovers: string[],
		missingProducts: MissingProductItem[]
	) {
		const modelId = products[key].modelId;
		// Armrest missing add cover to array
		if (!sofaRangeIsModular && modelId.includes('ARMREST')) {
			missingArmrestCovers.push(products[key].filter.color as string);
		}
		missingProducts.push({
			productId: products[key].productId,
			modelId,
			type: products[key].type,
			previousId: products[key].previousId as string,
			filter: {
				family: products[key].filter.family,
				color: products[key].filter.color,
			},
		});
		delete products[key];
	}

	private handleSprItems(
		sprItems: SprItem[],
		productInfo: ProductInfo,
		products: ProductData,
		key: string,
		sofaRangeIsModular: boolean,
		missingArmrestCovers: string[],
		missingProducts: MissingProductItem[],
		productId: string
	) {
		if (!sprItems.every((i) => productInfo[i.itemno])) {
			// Armrest missing add cover to array
			const hasArmrestInCover = Object.values(products).some(
				(prod: Product) =>
					prod.filter.color === products[key].filter.color && prod.modelId.includes('ARMREST')
			);
			if (!sofaRangeIsModular && !hasArmrestInCover) {
				missingArmrestCovers.push(products[key].filter.color as string);
			}
			missingProducts.push({
				productId: products[key].productId,
				modelId: products[key].modelId,
				type: products[key].type,
				previousId: products[key].previousId as string,
				filter: {
					family: products[key].filter.family,
					color: products[key].filter.color,
				},
			});
			delete products[key];
		} else if (!productInfo[productId]) {
			products[key]['sprIdInvalid'] = true;
		}
	}

	private removeProductsWithSpecificColor(
		products: ProductData,
		missingArmrestCovers: string[],
		missingProducts: MissingProductItem[]
	) {
		Object.entries(products).forEach(([key, product]) => {
			missingArmrestCovers.forEach(function (color) {
				if (products[key] && color === (product as Product).filter.color) {
					missingProducts.push({
						productId: products[key].productId,
						modelId: products[key].modelId,
						type: products[key].type,
						previousId: products[key].previousId as string,
						filter: {
							family: products[key].filter.family,
							color: products[key].filter.color,
						},
					});
					delete products[key];
				}
			});
		});
	}
}
